import Axios from "axios";

// Use local test server by default
const API_BASE_URL = process.env.REACT_APP_LLM_API_URL || "http://localhost:5000";

console.log('LLM API Configuration:', {
  baseURL: API_BASE_URL,
  environment: process.env.NODE_ENV
});

const llmAxiosInstance = Axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  withCredentials: false, // Set to false for local testing
  timeout: 60000 // Increase to 60 second timeout for slower connections
});

// Add debugging interceptors
llmAxiosInstance.interceptors.request.use(request => {
  console.log('Starting Request:', {
    url: request.url,
    method: request.method,
    data: request.data,
    headers: request.headers
  });
  return request;
});

llmAxiosInstance.interceptors.response.use(response => {
  console.log('Response:', {
    status: response.status,
    data: response.data,
    headers: response.headers
  });
  return response;
}, error => {
  console.log('Response Error:', {
    message: error.message,
    response: error.response?.data,
    status: error.response?.status
  });
  return Promise.reject(error);
});

export default llmAxiosInstance;
